module.exports = __webpack_public_path__ + "static/media/resource4.6fe185a9.svg";